import React from "react";

import FreeTrialForm from "./FreeTrialPopup";

function FreeTrialPage() {
    return (
        <div className="tw-bg-[#052F2F]">
            <FreeTrialForm is_full_page={true} />
        </div>)
}

export default FreeTrialPage;
